import { CloudOff, RotateCw, Trash2, Send, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyArt, Chip, cardCls, blueBtn } from "@/components/mobile/parts";
import { useMobile } from "@/context/MobileContext";
import { brl, fmtDateTime } from "@/lib/api";
import { cn } from "@/lib/utils";

function Entry({ e, onRetry, onDiscard }) {
  return (
    <li className={cn(cardCls, "space-y-1 p-3")} data-testid={`m-queue-${e.id}`}>
      <div className="flex items-start gap-2">
        <div className="flex-1">
          <p className="text-sm font-semibold">{e.type === "create" ? e.label : `Pedido · ${e.label}`}</p>
          <p className="text-xs text-slate-500">Guardado em {fmtDateTime(e.at)}</p>
        </div>
        {e.error ? <Chip tone="red">Erro</Chip> : <Chip tone="amber"><CloudOff className="h-3 w-3" />Aguardando</Chip>}
      </div>
      {e.lines && <p className="text-sm text-slate-700">{e.lines.join(", ")} · {brl(e.total)}</p>}
      {e.error && <p className="text-xs text-red-600" data-testid={`m-queue-error-${e.id}`}>{e.error}</p>}
      {e.error && (
        <div className="flex gap-2 pt-1">
          <Button variant="outline" size="sm" className="flex-1 text-red-600" onClick={() => window.confirm("Descartar este envio? Ele será apagado do celular.") && onDiscard(e.id)} data-testid={`m-queue-discard-${e.id}`}><Trash2 className="mr-1 h-4 w-4" />Descartar</Button>
          <Button size="sm" className={cn("flex-1", blueBtn)} onClick={() => onRetry(e.id)} data-testid={`m-queue-retry-${e.id}`}><RotateCw className="mr-1 h-4 w-4" />Tentar de novo</Button>
        </div>
      )}
    </li>
  );
}

export function QueueList() {
  const { queue, flush, retry, discard, online } = useMobile();
  return (
    <div className="space-y-3">
      <p className="text-xs text-slate-500">Quando a internet cai, as comandas novas e os pedidos ficam guardados neste celular e são enviados sozinhos quando a conexão volta.</p>
      {!queue.length ? <EmptyArt icon={CheckCircle2} title="Tudo enviado" text="Não há nada guardado no celular." testId="m-queue-empty" /> : (
        <>
          <Button className={cn("h-11 w-full", blueBtn)} onClick={flush} disabled={!online} data-testid="m-queue-send-now"><Send className="mr-2 h-4 w-4" />{online ? "Enviar agora" : "Sem internet"}</Button>
          <ul className="space-y-2" data-testid="m-queue-list">{queue.map((e) => <Entry key={e.id} e={e} onRetry={retry} onDiscard={discard} />)}</ul>
        </>
      )}
    </div>
  );
}
